import script from "./MenuComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuComponent.vue?vue&type=style&index=0&id=0113578f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0113578f"]])

export default __exports__